<template>
  <div class="btn-wrapper rounded-full" :class="classes">
    <router-link
      v-if="type === 'link'"
      :to="{ path: route }"
      v-ripple
      class="btn"
      >{{ text }}</router-link
    >
    <router-link
      v-else-if="type === 'sub-link'"
      :to="{ path: route }"
      v-ripple
      class="btn"
      >{{ text }}</router-link
    >
    <button
      v-ripple
      v-else-if="type === 'dynamic'"
      type="button"
			class="btn"
			:disabled="disable"
      @click="clickHandler"
    >
      <span class="btn__text relative"
        >{{ text }}
        <span class="btn__icon absolute">
          <SvgIcon icon="btn-icon" width="16px" height="17px" /> </span
      ></span>
    </button>
    <button v-else :type="type" class="btn" @click="clickHandler">
      {{ text }}
    </button>
  </div>
</template>

<script>
import SvgIcon from "./SvgIcon";
export default {
  name: "Button",
  components: { SvgIcon },
  props: {
    type: {
      type: String,
      default: "button"
    },
    text: {
      type: String
    },
    route: {
      default: ""
    },
    clickHandler: {
      default: function() {
        return false;
      }
    },
    classes: {
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  }
};
</script>
